<template>
  <!-- 非游客布局 -->
  <div
    :class="[
      { activity: hasBanner },
      { 'is-mobile': isMobile },
      defaultConfigStyle,
      'box-container',
    ]"
    @mouseenter="handleContainerHover('hover')"
    @mouseleave="handleContainerHover('leave')"
    v-if="!isDialog"
  >
    <template v-if="hasBanner">
      <EventInfo v-if="!isOldEvent" />
      <EventInfoOld v-if="isOldEvent" />
    </template>
    <slot name="logo"></slot>
    <div class="info-wrap" :class="[singleStatus ? configStyle : '']">
      <div class="info-header" v-if="!isMergeLoginAndRegister">
        <BaseLeftArrow class="back-row" v-if="hasBack" @click="handleClick" />
        <img :src="logoUrl" class="box-logo" alt="" v-if="logoUrl" />
        <div class="info-to" v-if="switchText">
          <span class="info-link a-custom" @click="switchTo">{{
            switchText
          }}</span>
        </div>
      </div>

      <div class="box-info">
        <div class="box-title" :class="titleClass" v-if="title">
          {{ title }}
        </div>
        <div class="box-title" :class="titleClass" v-if="subTitle">
          {{ subTitle }}
        </div>
        <div class="box-description" v-if="description">{{ description }}</div>
      </div>
      <slot name="form"></slot>
    </div>
    <LoginFooter v-if="hasCustomLoginPage && isMobile" />
  </div>
  <!-- 游客布局 -->
  <div
    v-else
    class="box-container dialog-container"
    :class="{
      activity: hasBanner,
      'is-mobile': isMobile,
      'is-mobiledialog': isMobileDialog,
    }"
    @mouseenter="handleContainerHover('hover')"
    @mouseleave="handleContainerHover('leave')"
  >
    <div class="info-wrap" :class="{ 'single-wrap': singleStatus }">
      <div class="info-header">
        <BaseLeftArrow class="back-row" v-if="hasBack" @click="handleClick" />
        <img :src="logoUrl" class="box-logo" alt="" />
        <div class="info-to" v-if="switchText">
          <span class="info-link a-custom" @click="switchTo">{{
            switchText
          }}</span>
        </div>
      </div>

      <div class="box-info">
        <div
          class="box-title"
          :class="{ cn: $i18n.locale === 'cn', njcb: businessType === 'njcb' }"
          v-if="title"
        >
          {{ title }}
        </div>
        <div class="box-description" v-if="description">{{ description }}</div>
      </div>
      <slot name="form"></slot>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import EventInfo from '@/components/event/EventInfo'
import EventInfoOld from '@/components/event/EventInfoOld'
import BaseLeftArrow from '@/components/common/BaseLeftArrow.vue'
import BaseMixin from '@/mixins/BaseMixin.js'
import { initSessionDate } from '@/utils/events.js'
import { mapGetters } from 'vuex'
import { isOldEventId } from '../../utils/utils'
import { getBusinessType } from '@/constant'
import LoginFooter from '@/components/login/LoginFooter.vue'

export default {
  name: '',
  mixins: [BaseMixin],
  props: {
    switchText: {
      // 需要配合switchTo方法一并传入
      type: [String],
      default: '',
    },
    hasBack: {
      type: [Boolean, String, Number],
      default: false,
    },
    title: {
      // 标题
      type: String,
      default: '',
      required: true,
    },
    subTitle: {
      // 标题
      type: String,
      default: '',
    },
    description: {
      // 描述
      type: String,
      default: '',
      required: false,
    },
    businessType: {
      // 类型，南京银行/公用
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      img: {},
    }
  },
  components: { BaseLeftArrow, EventInfo, EventInfoOld, LoginFooter },

  computed: {
    ...mapGetters(['eventData']),
    // 是否为旧版活动
    isOldEvent() {
      return isOldEventId(this.eventId)
    },
    logoUrl() {
      return getBusinessType().logoUrl
    },
    // 优化点：有一万个南京银行 样式如何处理
    configStyle() {
      return getBusinessType().className
    },
    hasOwnTheme() {
      return getBusinessType().hasOwnThemeStyle
    },
    defaultConfigStyle() {
      return getBusinessType().defaultContainer
    },
    isMergeLoginAndRegister() {
      return getBusinessType().isMergeLoginAndRegister
    },
    hasCustomLoginPage() {
      return getBusinessType().hasCustomLoginPage
    },
    singleStatus() {
      if (this.hasOwnTheme) {
        return true
      } else {
        return (
          (this.$route.name === 'ResetPassword' && !this.hasBanner) ||
          (this.$route.name === 'Register' &&
            this.step === 'account' &&
            !this.hasBanner)
        )
      }
    },
    unionId() {
      return getBusinessType().unionId
    },
    titleClass() {
      const type = this.businessType
      return {
        'njcb-title': type === 'njcb',
        'porsche-title': type === 'porsche',
        'zlzp-title': type === 'zlzp',
        'porschetaycan-title': this.unionId === 'porschetaycan',
        'takedaspark-title': type === 'takedaspark',
        'njcb-meets-title': type === 'njcb-meets',
        'nissan-title': type === 'nissan',
      }
    },
  },

  async created() {
    // 单次请求
    if (this.hasBanner) {
      if (!this.eventData) {
        await this.fetchEventData()
      }
    }
  },

  methods: {
    handleContainerHover(val) {
      this.$store.commit('setContainerHoverStatus', val)
    },
    handleClick() {
      this.$emit('back')
    },
    switchTo() {
      this.$emit('switchTo')
    },
    async fetchEventData() {
      let _data = null
      // 兼容新旧活动
      if (this.isOldEvent) {
        _data = await this.$api.events.GetEventData(this.eventId)
      } else {
        const { data } = await this.$api.events.FetchEventData(this.eventId)
        _data = data
      }
      initSessionDate(_data, this.isOldEvent)
      this.$store.commit('setEventData', _data)
      return _data
    },
  },
}
</script>
<style lang="scss" vars="{}" scoped>
$color-black: #14142b;
$color-gray: #5c5c5c;

.box-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 248px;
  transform: translateY(-50%);
  padding: 68px 72px 36px;
  background: rgba(255, 255, 255, 0.8);
  // backdrop-filter: blur(24px);
  border-radius: 32px;

  .info-to {
    font-size: 14px;
  }

  .back-row {
    position: absolute;
    top: 31px;
    left: 34px;
    padding: 5px;
    cursor: pointer;
  }

  .box-logo {
    // width: 100px;
    height: 26px;
  }

  &.activity {
    padding: 68px 60px 30px;
    width: 944px;
    left: 50%;
    // transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%);
    top: 80px;
  }

  .info-wrap {
    flex-shrink: 0;
    width: 325px;
  }

  .info-header {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    .info-link {
      color: #f0386c;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .box-title {
    font-size: 32px;
    line-height: 36px;
    font-weight: 600;
    padding: 12px 0;
    color: $color-black;
    margin-bottom: 4px;
    white-space: pre-line;
    &.cn {
      font-size: 30px;
    }
    &.njcb-title {
      font-size: 24px;
      line-height: 34px;
    }
  }
  .box-description {
    font-size: 14px;
    line-height: 20px;
    color: $color-gray;
  }
}
.zlzp-container {
  padding: 31px 20px 24px 20px;
  border-radius: 12px;
  .zlzp-title {
    white-space: unset;
    padding-top: unset;
  }
}
.is-mobile .box-container {
  display: block;
  width: 100%;
  transform: none;
  position: static;
  top: 0;
  left: 0;
  background-color: transparent;
  padding: 72px 16px 16px;
  .box-title {
    margin-bottom: 15px;
    white-space: pre-line;
    &.cn {
      font-size: 28px;
    }
    &.njcb-title {
      font-size: 24px;
      line-height: 34px;
    }
  }
  .porsche-title {
    margin-bottom: unset;
    white-space: unset;
    padding: unset;
    line-height: 43px;
    font-weight: 700;
    color: #000;
  }
  .porschetaycan-title {
    font-size: 28px;
  }
  .njcb-meets-title {
    margin-bottom: unset;
    white-space: unset;
    padding: unset;
    line-height: 43px;
    font-weight: 700;
  }
  .nissan-title {
    margin-bottom: unset;
    white-space: unset;
    padding: unset;
    height: 67px;
    box-sizing: border-box;
    line-height: 22px;
    font-weight: 400;
    font-size: 26px;
    color: #fff;
    background-image: url('../../assets/images/login/nissan-header.png');
    background-size: 100% 100%;
    padding-top: 24px;
    width: calc(100% + 40px);
    margin-left: -20px;
    text-align: center;
  }
  .takedaspark-title {
    margin-bottom: unset;
    white-space: unset;
    padding: unset;
    line-height: 45px;
    font-weight: 600;
    color: #000;
    font-size: 26px;
  }

  .zlzp-title {
    margin-bottom: unset;
    white-space: unset;
    padding: unset;
    line-height: 32px;
    font-size: 26px;
    font-weight: 600;
    color: #000;
  }
  .info-wrap {
    background: rgba(255, 255, 255, 0.8);
    // backdrop-filter: blur(24px);
    border-radius: 18px;
    padding: 20px;
    flex: 1;
    width: auto;
    height: auto;

    &.single-wrap {
      margin-top: 22%;
    }
    &.njcb {
      height: calc(100vh - 144px);
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .porsche-wrap,
  .takedaspark-wrap {
    background: #fff;
    backdrop-filter: blur(12px);
    padding: 24px 20px;
    border-radius: 12px;
    margin-top: 51px;
  }
  .njcb-meets-wrap {
    background: #fff;
    padding: 24px 20px;
    border-radius: 12px;
    margin-top: 138px;
  }
  .nissan-wrap {
    // padding: 0px 20px 12px;
    border-radius: 0px;
    // margin-top: 64px;
    margin: 4px 12px 0;
    background: rgba(255, 255, 255, 0);
    // background-image: url('../../assets/images/login/nissan-login-bg.png');
    // backdrop-filter: blur(30px);
    flex: 0;
    .box-info {
      display: none !important;
    }
  }
  .porsche911-wrap {
    backdrop-filter: blur(12px);
    padding: 24px 20px;
    border-radius: 12px;
    margin-top: 51px;
  }
  .porschetaycan-wrap {
    backdrop-filter: blur(12px);
    padding: 24px 20px;
    border-radius: 12px;
    margin-top: 20px;
  }
  .takedaspark-wrap {
    margin-top: 16vh;
  }
  .zlzp-wrap {
    margin-top: 26px;
    flex: 0;
  }

  .info-header {
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(4px);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 56px;
    align-items: center;
  }

  .back-row {
    margin-left: 17px;
    left: 0;
    top: 14px;
  }

  .info-to {
    position: absolute;
    right: 0;
    margin-right: 16px;
  }

  .box-logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 23px;
  }
}
.is-mobile {
  .njcb-container {
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding-top: 28px;
  }
  .porsche-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 63px;
    height: 100%;
  }
  .nissan-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // padding: 63px 20px 20px;
    padding: 0;
    height: 100%;
  }
  .zlzp-container {
    display: flex;
    flex-direction: column;
    padding-top: 20px;
    height: 100%;
  }
}
.box-container.dialog-container {
  background: none;
  padding: 55px 72px 40px;
  .info-header {
    position: static;
    background: none;
    margin-bottom: 12px;
    backdrop-filter: none;
    .box-logo {
      position: static;
      margin-left: 0;
      width: 100px;
      height: 26px;
    }
  }
  .info-wrap {
    padding: 0;
    background: none;
  }
  .box-title {
    padding: 0;
    margin-bottom: 60px;
    white-space: pre-line;
  }
  .back-row {
    position: absolute;
    top: 28px;
    left: 28px;
    padding: 5px;
    cursor: pointer;
  }
  .info-to {
    position: static;
  }
}
.is-mobiledialog.box-container.dialog-container {
  padding: 40px 20px 20px;
  .info-wrap {
    margin-top: 0;
  }
  .back-row {
    display: none;
  }
}
</style>
